export default __webpack_public_path__ + "static/media/patent03.f48c257d.png";